import { JSX } from 'preact'
import { previewProps } from '../../preview'
import { useAppSelector } from '../../store/store'
import { selectWidgetById } from '../../store/widgets'
import { selectGlobalSettings } from '../../store/globalSettings'
import { useWidgetContext } from '../useWidgetContext'

export const Logo = (): JSX.Element => {
  const { widgetId } = useWidgetContext()
  const version = useAppSelector(s => selectWidgetById(s, widgetId).version)
  const logoUrl = useAppSelector(s => selectGlobalSettings(s).logoUrl)

  if (version === 'V2' && logoUrl) {
    return (
      <div className="logo" {...previewProps('logo')}>
        <a href={logoUrl} target="_blank" rel="noopener noreferrer nofollow">
          Made in Getsitecontrol
        </a>
      </div>
    )
  }
}
